import { render, staticRenderFns } from "./basehousehold.vue?vue&type=template&id=f270ef70&"
import script from "./basehousehold.vue?vue&type=script&lang=js&"
export * from "./basehousehold.vue?vue&type=script&lang=js&"
import style0 from "./basehousehold.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports